var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getModuleSectionByChannelURL } from "../api/url";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { getLocalStorageItem, getUserAuthToken, getWhoAmIToken } from "../utils/storageHelper";
import { GoogleAnlyticsErrorLog, handleServerSideErrors } from "../utils/utils";
import { getByIdAPI, getListAPI } from "./crudSlice";
var initialState = {
    enableSearchInput: false,
    isMenuOpen: false,
    isFilterOpen: false,
    newProperty: true,
    selectedDesignation: "",
    notification: {
        type: "error",
        message: "",
        isOpen: false
    },
    newNotification: {
        type: "error",
        message: "",
        title: '',
        isOpen: false
    },
    dialog: {
        title: {},
        subTitle: {},
        onConfirm: {},
        isOpen: false,
        item: null
    },
    isLoader: false,
    mobileNumber: '',
    notificationList: [],
    isWorkShopViewActive: false,
    pushNotification: {
        message: "",
        isOpen: false
    },
    isCheckForApprovalMode: false,
    assignedMenus: [],
    branchChannel: {
        branchChannelName: "",
        getBranchChannelList: [],
        selectedBranchChannel: {}
    },
    selectedBranchDetails: {
        selectedBranchData: {}
    },
    updatedModuleSectionByChannel: [],
    getSavedTaskDetailsCount: {
        periodicMaintenanceCount: 0,
        standardJobsCount: 0,
        preCheckCount: 0,
        roadTestCount: 0,
        additionalJobsCount: 0,
        advisorSuggestionsCount: 0,
        futureAdviseCount: 0
    },
    tasksDetailsIsDisable: false,
    isDocDataUpdated: false,
    isTaskDetailDataUpdated: false,
    isFuelIndicatorSliderChanged: false,
    taskDetailDataSaved: false,
    accordianClosed: false,
    getTaskDetailsToggleValue: {
        periodicMaintenanceToggle: false,
        standardJobsToggle: false,
        preCheckToggle: false,
        roadTestToggle: false,
        additionalJobsToggle: false
    },
    jobCardTaskDetailsSummary: [],
    roadTestPDIData: {},
    customerVoiceSectionDetails: null,
    precheckSectionDetails: null,
    baySection: null,
    isAllViewActive: false,
    safeAreaMargin: {
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    }
};
var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
export var downloadAttachment = function (DocumentId, AttachmentId, url) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var authData, tokenData, configData;
    return __generator(this, function (_a) {
        try {
            authData = getUserAuthToken();
            tokenData = authData ? authData : getWhoAmIToken();
            configData = {
                headers: {}
            };
            if (tokenData) {
                configData.headers['Authorization'] = "Bearer ".concat(tokenData);
                configData.headers['Access-Control-Allow-Credentials'] = true;
                configData.headers['Content-Type'] = 'application/json';
                configData.headers["ChannelId"] = storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId;
                configData.responseType = 'blob';
                configData.withCredentials = true;
            }
            axios.get(url + AttachmentId + '/' + DocumentId, configData).then(function (response) {
                if (response.status === 200) {
                    var reader_1 = new window.FileReader();
                    reader_1.readAsDataURL(response.data);
                    reader_1.onload = function () {
                        var imageDataUrl = reader_1.result;
                        resolve(imageDataUrl);
                    };
                }
                else {
                    reject(response);
                }
            }).catch(function (error) {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
        return [2 /*return*/];
    });
}); }); };
export var downloadProfileAttachment = function (IdentityId, AttachmentId, url) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var authData, tokenData, configData;
    return __generator(this, function (_a) {
        try {
            authData = getUserAuthToken();
            tokenData = authData ? authData : getWhoAmIToken();
            configData = {
                headers: {}
            };
            if (tokenData) {
                configData.headers['Authorization'] = "Bearer ".concat(tokenData);
                configData.headers['Access-Control-Allow-Credentials'] = true;
                configData.headers['Content-Type'] = 'application/json';
                configData.headers["ChannelId"] = storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId;
                configData.responseType = 'blob';
                configData.withCredentials = true;
            }
            axios.get(url + IdentityId + '/' + AttachmentId, configData).then(function (response) {
                if (response.status === 200) {
                    var reader_2 = new window.FileReader();
                    reader_2.readAsDataURL(response.data);
                    reader_2.onload = function () {
                        var imageDataUrl = reader_2.result;
                        resolve(imageDataUrl);
                    };
                }
                else {
                    reject(response);
                }
            }).catch(function (error) {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
        return [2 /*return*/];
    });
}); }); };
export var validateDocumentFunction = createAsyncThunk("validateDocument", function (_ref, _ref2) { return __awaiter(void 0, void 0, void 0, function () {
    var url, request, dispatch, validateDocument;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = _ref.url, request = _ref.request;
                dispatch = _ref2.dispatch;
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: url,
                        request: request
                    }))];
            case 2:
                validateDocument = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, validateDocument];
        }
    });
}); });
export var getDocumentByIdAPIFunction = createAsyncThunk("getDocumentById", function (_ref3, _ref4) { return __awaiter(void 0, void 0, void 0, function () {
    var key, url, dispatch, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = _ref3.key, url = _ref3.url;
                dispatch = _ref4.dispatch;
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url
                    }))];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, response.payload];
        }
    });
}); });
export var moduleSectionsByChannelFunction = createAsyncThunk("moduleDectionByChannel", function (_ref5, _ref6) { return __awaiter(void 0, void 0, void 0, function () {
    var _response$payload, _response$payload2, request, dispatch, profileData, response, _response$payload3, _response$payload4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                request = _ref5.request;
                dispatch = _ref6.dispatch;
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: getModuleSectionByChannelURL,
                        request: request
                    }))];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    GoogleAnlyticsErrorLog(profileData, getModuleSectionByChannelURL, handleServerSideErrors(response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.value), request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: handleServerSideErrors(response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.value),
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var CloneParentDocumentTask = createAsyncThunk("getParentDocumentId", function (_ref7, _ref8) { return __awaiter(void 0, void 0, void 0, function () {
    var url, request, dispatch, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = _ref7.url, request = _ref7.request;
                dispatch = _ref8.dispatch;
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        url: url,
                        request: request
                    }))];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, response.payload];
        }
    });
}); });
export var commonReducerSlice = createSlice({
    name: "commonReducer",
    initialState: initialState,
    reducers: {
        setIsLeftMenuOpen: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isMenuOpen: action.payload
            });
        },
        setIsFilterOpen: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isMenuOpen: action.payload
            });
        },
        showNotification: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notification: action.payload
            });
        },
        showNewNotification: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                newNotification: action.payload
            });
        },
        clearNotification: function (state) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notification: _objectSpread(_objectSpread({}, state.notification), {}, {
                    isOpen: false
                })
            });
        },
        confirmDialogOpen: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                dialog: action.payload
            });
        },
        confirmDialogClose: function (state) {
            return _objectSpread(_objectSpread({}, state), {}, {
                dialog: _objectSpread(_objectSpread({}, state.dialog), {}, {
                    isOpen: false
                })
            });
        },
        showLoader: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isLoader: action.payload
            });
        },
        setSelectedDesignation: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                selectedDesignation: action.payload
            });
        },
        setIsAllViewActive: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isAllViewActive: action.payload
            });
        },
        setNotificationList: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notificationList: action.payload
            });
        },
        showPushNotification: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                pushNotification: action.payload
            });
        },
        setIsCustomerApprovalMode: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isCheckForApprovalMode: action.payload
            });
        },
        setAssignedMenus: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                assignedMenus: action.payload
            });
        },
        setBranchChannelList: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                branchChannel: action.payload
            });
        },
        setSelectedBranchDetails: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                selectedBranchDetails: action.payload
            });
        },
        setUpdatedModuleSectionByChannel: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                updatedModuleSectionByChannel: action.payload
            });
        },
        setSavedTaskDetailsCount: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                getSavedTaskDetailsCount: _objectSpread(_objectSpread({}, state.getSavedTaskDetailsCount), action.payload)
            });
        },
        setTasksDetailsIsDisable: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                tasksDetailsIsDisable: action.payload
            });
        },
        setDocDataUpdated: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isDocDataUpdated: action.payload
            });
        },
        setIsTaskDetailsDataUpdated: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isTaskDetailDataUpdated: action.payload
            });
        },
        setIsFuelIndicatorSliderChanged: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                isFuelIndicatorSliderChanged: action.payload
            });
        },
        setTaskDetailsDataSaved: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                taskDetailDataSaved: action.payload
            });
        },
        setAccordianClosed: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                accordianClosed: action.payload
            });
        },
        setTaskDetailsToggleValue: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                getTaskDetailsToggleValue: action.payload
            });
        },
        setJobCardTaskDetailsSummary: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                jobCardTaskDetailsSummary: action.payload
            });
        },
        setRoadTestPDIData: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                roadTestPDIData: action.payload
            });
        },
        setCustomerVoiceSectionDetails: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                customerVoiceSectionDetails: action.payload
            });
        },
        setPrecheckSectionDetails: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                precheckSectionDetails: action.payload
            });
        },
        setBaySection: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                baySection: action.payload
            });
        },
        resetCommonReducer: function () { return initialState; },
        showError: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notification: {
                    message: action.payload,
                    isOpen: true,
                    type: 'error'
                }
            });
        },
        showSuccess: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notification: {
                    message: action.payload,
                    isOpen: true,
                    type: 'success'
                }
            });
        },
        showInfo: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                notification: {
                    message: action.payload,
                    isOpen: true,
                    type: 'info'
                }
            });
        },
        setEnableSearchInput: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                enableSearchInput: action.payload
            });
        },
        setSafeAreaMargin: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                safeAreaMargin: action.payload
            });
        }
    }
});
export var setEnableSearchInput = (_a = commonReducerSlice.actions, _a.setEnableSearchInput), setIsLeftMenuOpen = _a.setIsLeftMenuOpen, showNotification = _a.showNotification, showNewNotification = _a.showNewNotification, clearNotification = _a.clearNotification, confirmDialogOpen = _a.confirmDialogOpen, confirmDialogClose = _a.confirmDialogClose, showLoader = _a.showLoader, resetCommonReducer = _a.resetCommonReducer, setSelectedDesignation = _a.setSelectedDesignation, setIsFilterOpen = _a.setIsFilterOpen, setIsAllViewActive = _a.setIsAllViewActive, setNotificationList = _a.setNotificationList, showPushNotification = _a.showPushNotification, setIsCustomerApprovalMode = _a.setIsCustomerApprovalMode, setAssignedMenus = _a.setAssignedMenus, setBranchChannelList = _a.setBranchChannelList, setSelectedBranchChannel = _a.setSelectedBranchChannel, setSelectedBranchDetails = _a.setSelectedBranchDetails, setUpdatedModuleSectionByChannel = _a.setUpdatedModuleSectionByChannel, setSavedTaskDetailsCount = _a.setSavedTaskDetailsCount, setTasksDetailsIsDisable = _a.setTasksDetailsIsDisable, setDocDataUpdated = _a.setDocDataUpdated, setIsTaskDetailsDataUpdated = _a.setIsTaskDetailsDataUpdated, setIsFuelIndicatorSliderChanged = _a.setIsFuelIndicatorSliderChanged, setTaskDetailsDataSaved = _a.setTaskDetailsDataSaved, setAccordianClosed = _a.setAccordianClosed, setTaskDetailsToggleValue = _a.setTaskDetailsToggleValue, setJobCardTaskDetailsSummary = _a.setJobCardTaskDetailsSummary, setRoadTestPDIData = _a.setRoadTestPDIData, setCustomerVoiceSectionDetails = _a.setCustomerVoiceSectionDetails, setPrecheckSectionDetails = _a.setPrecheckSectionDetails, setBaySection = _a.setBaySection, showError = _a.showError, showSuccess = _a.showSuccess, showInfo = _a.showInfo, setSafeAreaMargin = _a.setSafeAreaMargin;
var commonReducer = commonReducerSlice.reducer;
export default commonReducer;
